/* Black Kitty product page behaviours. Classic script, no dependencies. */
(function () {
  'use strict';

  /* Announcement bar: rotate slides */
  document.querySelectorAll('[data-bk-announce]').forEach(function (bar) {
    var slides = bar.querySelectorAll('.bk-announce__slide');
    if (slides.length < 2) return;
    var i = 0, speed = (parseInt(bar.dataset.speed, 10) || 5) * 1000;
    setInterval(function () {
      slides[i].classList.remove('is-on');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-on');
    }, speed);
  });

  /* Gallery: thumbnails drive the track; an IntersectionObserver on the slides keeps the active thumb in sync and in view */
  document.querySelectorAll('[data-bk-gallery]').forEach(function (g) {
    var track = g.querySelector('.bk-gallery__track');
    var slides = Array.prototype.slice.call(track.querySelectorAll('.bk-gallery__slide'));
    var strip = g.querySelector('.bk-gallery__thumbs');
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('.bk-gallery__thumb'));
    var active = 0;
    function revealThumb(k) {
      var t = thumbs[k]; if (!t || !strip) return;
      // keep the active thumb AND its neighbours in view, so the next image is always visible
      var first = thumbs[Math.max(0, k - 1)], lastN = thumbs[Math.min(thumbs.length - 1, k + 1)];
      var left = first.offsetLeft - strip.offsetLeft, right = lastN.offsetLeft - strip.offsetLeft + lastN.offsetWidth, pad = 8;
      var target = null;
      if (left - pad < strip.scrollLeft) target = Math.max(0, left - pad);
      else if (right + pad > strip.scrollLeft + strip.clientWidth) target = Math.min(strip.scrollWidth - strip.clientWidth, right + pad - strip.clientWidth);
      if (target !== null) strip.scrollLeft = target;
    }
    function setActive(k) {
      active = k;
      thumbs.forEach(function (t, i) { t.classList.toggle('is-on', i === k); t.setAttribute('aria-current', i === k ? 'true' : 'false'); });
      revealThumb(k);
    }
    var busy = null;
    function settle() { busy = null; }
    function go(n) {
      n = (n + slides.length) % slides.length;
      setActive(n);
      clearTimeout(busy); busy = setTimeout(settle, 1500);
      track.scrollTo({ left: slides[n].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    track.addEventListener('scrollend', function () { if (busy) { clearTimeout(busy); settle(); } });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var prev = g.querySelector('.bk-gallery__arrow--prev'), next = g.querySelector('.bk-gallery__arrow--next');
    if (prev) prev.addEventListener('click', function () { go(active - 1); });
    if (next) next.addEventListener('click', function () { go(active + 1); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (busy) return;
          if (en.isIntersecting && en.intersectionRatio >= 0.6) {
            var k = slides.indexOf(en.target);
            if (k !== -1 && k !== active) setActive(k);
          }
        });
      }, { root: track, threshold: [0.6] });
      slides.forEach(function (s) { io.observe(s); });
    }
    setActive(0);
  });

  /* Buy box: purchase-type toggle + offer tiles + selling plan */
  document.querySelectorAll('[data-bk-buybox]').forEach(function (box) {
    var form = box.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    var variantInput = form.querySelector('input[name="id"]');
    var planInput = form.querySelector('input[name="selling_plan"]');
    var offers = box.querySelectorAll('.bk-offer');
    var modeInputs = box.querySelectorAll('input[name="bk-mode"]');
    var money = box.dataset.moneyFormat || '${{amount}}';

    function fmt(cents) {
      var n = (cents / 100);
      var s = (Math.round(n * 100) / 100).toFixed(2);
      if (s.slice(-3) === '.00') s = s.slice(0, -3);
      return money.replace(/\{\{\s*amount\w*\s*\}\}/, s);
    }
    function mode() {
      var m = 'onetime';
      modeInputs.forEach(function (i) { if (i.checked) m = i.value; });
      return m;
    }
    function selectedOffer() {
      var sel = null;
      offers.forEach(function (o) { if (o.querySelector('input[type="radio"]').checked) sel = o; });
      return sel;
    }
    var qtyInput = form.querySelector('[data-bk-qty]');
    var pfc = box.querySelector('product-form-component');
    function render() {
      var m = mode();
      offers.forEach(function (o) {
        var r = o.querySelector('input[type="radio"]');
        o.classList.toggle('is-selected', r.checked);
        var unit = parseInt(o.dataset.unit, 10), cmp = parseInt(o.dataset.compareUnit, 10) || unit;
        var qty = parseInt(o.dataset.qty, 10) || 1, paid = parseInt(o.dataset.paid, 10) || qty;
        var subUnit = parseInt(o.dataset.subUnit, 10);
        var sub = (m === 'subscribe' && !isNaN(subUnit)), subAll = sub && o.dataset.subAll === '1';
        var u = sub ? subUnit : unit;
        var price = subAll ? u * qty : u * paid, strike = cmp * qty;
        if (sub && cmp <= unit) strike = unit * qty;
        var el;
        if ((el = o.querySelector('[data-price]'))) el.textContent = fmt(price);
        if ((el = o.querySelector('[data-was]'))) { el.hidden = !(strike > price); el.textContent = strike > price ? fmt(strike) : ''; }
        if ((el = o.querySelector('[data-save-line]'))) el.textContent = strike > price ? (box.dataset.savePrefix || 'You save') + ' ' + fmt(strike - price) : '';
        if ((el = o.querySelector('[data-per]'))) el.textContent = qty > 1 ? fmt(Math.round(price / qty)) + ' ' + (el.dataset.suffix || 'per pouch') : '';
      });
      var sel = selectedOffer();
      if (sel) {
        variantInput.value = sel.dataset.variantId;
        var subSel = (m === 'subscribe' && sel.dataset.planId);
        var oneLine = !subSel || sel.dataset.subAll === '1';
        var q = oneLine ? (parseInt(sel.dataset.qty, 10) || 1) : (parseInt(sel.dataset.paid, 10) || parseInt(sel.dataset.qty, 10) || 1);
        if (qtyInput) qtyInput.value = q;
        if (pfc) pfc.dataset.quantityDefault = q;
        if (planInput) planInput.value = (m === 'subscribe' && sel.dataset.planId) ? sel.dataset.planId : '';
        var daySpan = box.querySelector('[data-perday-text]');
        if (daySpan) {
          var unit = parseInt(sel.dataset.unit, 10), subUnit = parseInt(sel.dataset.subUnit, 10);
          var qty = parseInt(sel.dataset.qty, 10) || 1, paid = parseInt(sel.dataset.paid, 10) || qty;
          var subD = (m === 'subscribe' && !isNaN(subUnit));
          var day = subD ? (sel.dataset.subAll === '1' ? subUnit / 30 : (subUnit * paid) / (qty * 30)) : (unit * paid) / (qty * 30);
          daySpan.textContent = ((daySpan.dataset.prefix || 'Less than').trim() + ' $' + (Math.ceil(day) / 100).toFixed(2) + ' ' + (daySpan.dataset.suffix || 'a day').trim()).trim();
        }
      }
      var subNote = box.querySelector('[data-sub-note]');
      if (subNote) subNote.hidden = m !== 'subscribe';
      var bumpWrap = box.querySelector('[data-bk-bump]');
      if (bumpWrap && sel) {
        var included = sel.dataset.hasGift === '1';
        bumpWrap.hidden = included;
        if (included) { var cb = bumpWrap.querySelector('input'); if (cb) cb.checked = false; }
      }
    }
    offers.forEach(function (o) { o.querySelector('input[type="radio"]').addEventListener('change', render); });
    modeInputs.forEach(function (i) { i.addEventListener('change', render); });
    render();

    /* Submit. One-time: the form adds the PAID pouches and the free ones go in as a separate one-time line
       (Shopify's Buy X Get Y only discounts one-time lines). Subscribe: ALL pouches go on the offer's plan in one
       line, so every renewal is the same pouches at the same price (the plan price already includes the "free" one).
       Plus the gift and the bump. Listening on window in the capture phase runs before the theme's own submit handler. */
    var bump = box.querySelector('input[name="bk-bump"]');
    var skip = false;
    window.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      if (skip) { skip = false; return; }
      var sel = selectedOffer();
      if (!sel) return;
      /* feedback: spinner on the button until the cart reports the update (or 8s as a safety net) */
      var atc = form.querySelector('button[type="submit"], [type="submit"]');
      if (atc) { atc.classList.add('bk-atc-loading'); clearTimeout(atc._bkT); atc._bkT = setTimeout(function () { atc.classList.remove('bk-atc-loading'); }, 8000); }
      var m = mode();
      var qty = parseInt(sel.dataset.qty, 10) || 1, paid = parseInt(sel.dataset.paid, 10) || qty;
      var subbing = (m === 'subscribe' && sel.dataset.planId);
      /* One line for all pouches in both modes. One-time: Shopify's Buy X Get Y discount takes the free one off
         that line. Subscribe: the plan price already covers every pouch. (Falls back to a separate free one-time
         line only for an offer subscribing on a plan that does not include the free pouch.) */
      var oneLine = !subbing || sel.dataset.subAll === '1';
      var add = oneLine ? qty : paid, free = oneLine ? 0 : qty - paid;
      if (qtyInput) qtyInput.value = add;
      if (pfc) pfc.dataset.quantityDefault = add;
      if (planInput) planInput.value = subbing ? sel.dataset.planId : '';
      var extras = [];
      if (free > 0) extras.push({ id: parseInt(sel.dataset.variantId, 10), quantity: free });
      if (sel.dataset.giftVariantId) extras.push({ id: parseInt(sel.dataset.giftVariantId, 10), quantity: 1 });
      if (bump && bump.checked && bump.dataset.variantId) extras.push({ id: parseInt(bump.dataset.variantId, 10), quantity: 1 });
      if (!extras.length) return;
      e.preventDefault(); e.stopImmediatePropagation();
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: extras })
      }).catch(function () {}).then(function () { skip = true; form.requestSubmit(); });
    }, true);
  });

  /* Sticky header: always, or only when scrolling up. The whole header group sticks with a negative top
     offset so the announcement bar scrolls away and only the header stays. */
  document.querySelectorAll('[data-bk-header]').forEach(function (h) {
    var mode = h.dataset.sticky || 'up';
    if (mode === 'off') return;
    var sec = h.closest('.shopify-section') || h;
    var wrap = document.getElementById('header-group');
    if (!wrap || !wrap.contains(sec)) wrap = sec;
    wrap.classList.add('bk-sticky-header');
    function offset() {
      var d = sec.getBoundingClientRect().top - wrap.getBoundingClientRect().top;
      wrap.style.setProperty('--bk-head-top', (-Math.max(0, Math.round(d))) + 'px');
    }
    offset(); window.addEventListener('resize', offset); window.addEventListener('load', offset);
    if (mode === 'always') return;
    var scroller = document.querySelector('.page-wrapper'), last = 0, ticking = false;
    function pos() {
      return Math.max(window.scrollY || 0, document.scrollingElement ? document.scrollingElement.scrollTop : 0, scroller ? scroller.scrollTop : 0);
    }
    function check() {
      var y = pos();
      if (y < 80) wrap.classList.remove('is-hidden');
      else if (y > last + 4) wrap.classList.add('is-hidden');
      else if (y < last - 4) wrap.classList.remove('is-hidden');
      last = y; ticking = false;
    }
    document.addEventListener('scroll', function (e) {
      if (e.target !== document && e.target !== scroller) return;
      if (!ticking) { ticking = true; requestAnimationFrame(check); }
    }, true);
    last = pos();
  });

  /* UGC mosaic: start scrolled to the centre so the outer tiles are cut off on both sides */
  document.querySelectorAll('[data-bk-ugc]').forEach(function (el) {
    function centre() { if (getComputedStyle(el).overflowX !== 'auto') { el.scrollLeft = 0; return; } el.scrollLeft = Math.max(0, (el.scrollWidth - el.clientWidth) / 2); }
    centre(); window.addEventListener('resize', centre); window.addEventListener('load', centre);
  });

  /* Phone carousels: scroll-snap track + arrows + dots. One "page" = the visible cards. */
  document.querySelectorAll('[data-bk-carousel]').forEach(function (el) {
    var track = el.querySelector('[data-track]'), prev = el.querySelector('[data-prev]'), next = el.querySelector('[data-next]');
    var dots = Array.prototype.slice.call(el.querySelectorAll('.bk-ingnav__dot'));
    if (!track) return;
    function pageW() { return track.clientWidth + (parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0); }
    function pages() { return Math.max(1, Math.ceil((track.scrollWidth + 1) / pageW())); }
    function page() { return Math.round(track.scrollLeft / pageW()); }
    function go(n) { track.scrollTo({ left: Math.max(0, Math.min(n, pages() - 1)) * pageW(), behavior: 'smooth' }); }
    function sync() {
      var p = page(), max = track.scrollWidth - track.clientWidth - 2;
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === p); });
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { go(page() - 1); });
    if (next) next.addEventListener('click', function () { go(page() + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    track.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync); sync();
  });

  /* Cart drawer: shipping protection add-on. The toggle adds/removes the add-on product and refreshes the
     drawer through Horizon's own cart event. On by default; turning it off is remembered for the session. */
  (function () {
    var KEY = 'bk-ship-off', busy = false;
    function root() { return (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'); }
    function announce(cart) {
      var ev = new CustomEvent('shopify:cart:lines-update', { bubbles: true, detail: { source: 'bk-ship' } });
      ev.promise = Promise.resolve({ cart: { totalQuantity: cart.item_count }, detail: { sections: cart.sections, itemCount: cart.item_count, source: 'bk-ship' } });
      document.dispatchEvent(ev);
      /* the re-render keeps the old checkbox state, so sync it (and the line key) from the cart itself */
      var line = (cart.items || []).filter(function (i) { return i.handle === 'shipping-protection'; })[0];
      function sync() {
        document.querySelectorAll('[data-bk-ship]').forEach(function (b) {
          b.dataset.key = line ? line.key : '';
          var t = b.querySelector('[data-bk-ship-toggle]'); if (t) t.checked = !!line;
        });
      }
      sync(); setTimeout(sync, 400); setTimeout(sync, 1200);
    }
    function post(url, body) {
      body.sections = 'cart-drawer-section'; body.sections_url = window.location.pathname;
      return fetch(root() + url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
    }
    function add(variant) { return post('cart/add.js', { items: [{ id: parseInt(variant, 10), quantity: 1 }] }).then(function () { return post('cart/update.js', {}); }); }
    function remove(key) { return post('cart/change.js', { id: key, quantity: 0 }); }
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('[data-bk-ship-toggle]') || busy) return;
      var box = t.closest('[data-bk-ship]'); if (!box) return;
      busy = true;
      var p = t.checked ? add(box.dataset.variant) : remove(box.dataset.key);
      try { if (t.checked) sessionStorage.removeItem(KEY); else sessionStorage.setItem(KEY, '1'); } catch (err) {}
      p.then(function (cart) { if (cart && cart.sections) announce(cart); }).catch(function () {}).then(function () { busy = false; });
    });
    /* default on: add it once when a cart exists without it and she hasn't switched it off */
    function autoAdd() {
      var box = document.querySelector('[data-bk-ship]'); if (!box) return;
      var off = false; try { off = sessionStorage.getItem(KEY) === '1'; } catch (err) {}
      if (off || box.dataset.key || busy) return;
      busy = true;
      add(box.dataset.variant).then(function (cart) { if (cart && cart.sections) announce(cart); }).catch(function () {}).then(function () { busy = false; });
    }
    autoAdd();
    document.addEventListener('shopify:cart:lines-update', function (e) {
      if (e.detail && e.detail.source === 'bk-ship') return;
      if (e.promise) e.promise.then(function () { setTimeout(autoAdd, 300); }).catch(function () {});
    });
  })();

  /* Add-to-cart spinner off once the cart has updated; desktop: a click on the dimmed page closes the cart drawer */
  document.addEventListener('shopify:cart:lines-update', function (e) {
    function done() { document.querySelectorAll('.bk-atc-loading').forEach(function (b) { b.classList.remove('bk-atc-loading'); clearTimeout(b._bkT); }); }
    if (e.promise) e.promise.then(function () { setTimeout(done, 150); }).catch(done); else setTimeout(done, 400);
  });
  /* Asset protection: no context menu or drag on images and videos. Text stays selectable and copyable. */
  document.addEventListener('contextmenu', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('img, video, picture, svg, .bk-gallery, .bk-ugc__tile')) e.preventDefault();
  });
  document.addEventListener('dragstart', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('img, video, picture, svg')) e.preventDefault();
  });

  /* Ship-by date */
  document.querySelectorAll('[data-bk-shipby]').forEach(function (el) {
    var days = parseInt(el.dataset.days, 10) || 1, d = new Date(), added = 0;
    while (added < days) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) added++; }
    el.textContent = d.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
  });

  /* Sticky bar: shows once the add-to-cart button has scrolled above the viewport (works with any scroll container) */
  document.querySelectorAll('[data-bk-sticky]').forEach(function (bar) {
    var target = document.querySelector(bar.dataset.watch);
    if (!target) return;
    var ticking = false;
    function check() {
      var r = target.getBoundingClientRect();
      var footer = document.querySelector('.bk-footer');
      var nearFooter = footer && footer.getBoundingClientRect().top < window.innerHeight;
      bar.classList.toggle('is-on', r.bottom < 0 && !nearFooter);
      ticking = false;
    }
    document.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, true);
    window.addEventListener('resize', check);
    check();
    var btn = bar.querySelector('[data-scroll-to]');
    if (btn) btn.addEventListener('click', function (e) { e.preventDefault(); var to = (btn.dataset.target && document.querySelector(btn.dataset.target)) || target; to.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
  });

  /* Ingredient tabs */
  document.querySelectorAll('[data-bk-tabs]').forEach(function (wrap) {
    var tabs = wrap.querySelectorAll('.bk-tab'), panels = wrap.querySelectorAll('.bk-panel');
    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x, j) { x.classList.toggle('is-on', j === k); x.setAttribute('aria-selected', j === k); });
        panels.forEach(function (p, j) { p.classList.toggle('is-on', j === k); });
      });
    });
  });

  /* Animated counters */
  var counters = document.querySelectorAll('[data-bk-count]');
  if (counters.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target, end = parseInt(el.dataset.bkCount, 10); io.unobserve(el);
        if (isNaN(end)) return;
        var start = performance.now(), dur = 1200;
        (function step(now) {
          var p = Math.min(1, (now - start) / dur), v = Math.round(end * (1 - Math.pow(1 - p, 3)));
          el.textContent = v + (el.dataset.suffix || '');
          if (p < 1) requestAnimationFrame(step);
        })(start);
      });
    }, { threshold: .4 });
    counters.forEach(function (c) { io.observe(c); });
  }
})();
